import SignatureCanvas from "react-signature-canvas";
import { Button, Modal } from "react-bootstrap";
import closeIcon from 'assets/images/close.svg';

const SignatureModal = ({ show, closeHandler, signRef, handleCreateSign }) => {
    return (
        <Modal show={show} size='md' onHide={closeHandler} contentClassName='signupMap'>
            <Modal.Header>
                <h6>Add Signature</h6>
                <img src={closeIcon} alt="close" className='close-icon cursor-pointer' onClick={closeHandler} />
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-center mb-3">
                    Please sign here...
                </div>
                <SignatureCanvas penColor="black" canvasProps={{
                    
                    style: {
                        background: '#e9f0f6',
                        borderRadius: '5px',
                        width: '100%',
                        height: '200px',
                        maxWidth: '465px'
                    }
                }}
                    ref={signRef}
                />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Button onClick={handleCreateSign}>Save</Button>
            </Modal.Footer>
        </Modal>);
}

export default SignatureModal;